import {Injectable} from '@angular/core'
import {BehaviorSubject} from 'rxjs';
import {AuthHttpService} from "./services/auth-http.service";
import {CreateDialogComponent} from "./shared/dialogs/create-dialog/create-dialog.component";
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import {forkJoin} from 'rxjs';
import {Clipboard} from '@angular/cdk/clipboard';

@Injectable({
  providedIn: "root"
})
export class Globals {

  //VERSION OF WEB INTERFACE

    public version = '3.7.1025'; // не забывать исправлять в translate.ts и db_version.php(!)

  //сокет URL
  public ws_url: any;

  public error: boolean = true;
  public lang: string = 'en';
  public road: string = 'en';
  public equipment: string = 'en';
  public hiddenAdmin: boolean;
  public user: any;
  public select_project: any;
//translate js
  public langJS = new BehaviorSubject('');

  public roadJS = new BehaviorSubject('');
  public equipmentJS = new BehaviorSubject('');
//смена проекта
  public chProj = new BehaviorSubject('');

// roles and privelegies
  public superadmin = '7f116e4f-018c-435b-93e0-327151cc5108';

  public mainPrivs = ["69770f3c-3047-f1e7-3f65-87f4792fc013", "5e686f03-b975-5dee-01ba-d9f877b8fb5d", "37d60352-b0bc-b06c-bf89-a066213cfbf1", "1bc0e953-6fff-67e2-4eaa-373851af14af"];
  public adminPrivs = ["97dba9b4-4b97-f6aa-cfb8-f00665565e74", "3e298e0c-7dcd-2c31-cdc5-cdc48eb7ac0b", "9d9ffa59-9878-da1c-47a6-7db9ad5ce0bd", "363ac050-bd4f-f5d3-7343-b606571eb8c0", "891ea20b-8cbc-0c8b-3ccf-54f4d66d9161", "6970f523-4c18-74b5-bb4f-5cf9f8151e85", "f8c6ff2a-c67a-4cc7-9871-c1bc888fe2af", "0e2c7e13-978e-abee-0682-58cda95aa578"];
  public adminUserPrivs = ["e1b4f188-72de-5d6d-26f6-db92811111bc", "c89cacc5-e683-d4bb-1c93-3c29a3eaf448", "20ff326b-4970-c935-be8a-648272d6921d", "8a4b4591-1825-e0d9-e0a3-1c34d83ac5cc"];
  public imageMimeTypes = ["image/gif", "image/png", "image/jpg", "image/jpeg", "image/webp"];

//event rules
  public catList = [];
  public typeList = [];
  public eventRules = [];

  //for min create date of project sensors
  public minDate: NgbDateStruct;
  public createList = [];
  public show_proj_sel = false;
  // список url для показа селекта проектов в шапке
  public urls = [
    '/main',
    '/report/sensor-statistics',
    '/report/consolidated-statistics',
    '/report/consolidated-statistics-gk',
    '/admin/tracking',
    '/report/sensor-events',
    '/report/consolidated-events',
    '/report/sensor-primary-report',
    '/admin/admin-sensors-test',
    '/report/status-diagram',
    '/road-management-new/project-roads',
    '/report/all-events'
  ];

  /**
   * системные параметры из таблицы sys_params
   */
  public systemParams: any;
  public data_has_changed = false;
  public reload_project = false;
  changeLangCancel: any;

  //маска для ввода названий без пробела в начале
  public maskcode = [/\S/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/, /(.*?)/];

  //маска для ввода цифровых значений
  public maskport = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];

  public mask_index = [/^[1-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
  public mask_lanes = [/^[1-9]/, /[0-9]/];
  public days_mask = [/^[1-9]/, /[0-9]/, /[0-9]/];
  public percent_mask = [/([0-9]|\.)/, /([0-9]|\.)/, /([0-9]|\.)/, /[0-9]/, /[0-9]/];
  public sign_in: boolean = false;
  public lane_type: string;
  public road_type: string;
  public road_editor_lang: string;
  public roads: string;
  public roadPages: any;
  public equipment_menu: any;
  selectedProjectId: string = '';
  cabinets_lang: string;
  sensors_lang: string;
  adapters_lang: string;
  switch_on_lang: string;
  switch_off_lang: string;
  calendarInterval: boolean = true;

  checkQuantity(num) {
  }

    name_mask(rawValue: string): RegExp[] {
      const size = 70;
      const mask = /^[а-яА-ЯёЁa-zA-Z0-9_.\s+]+$/;

    // For not limit string length use below commented string.
    const nameMask: RegExp[] = [];
    for (let i = 0; i <= size; i++) {
      nameMask.push(mask);
    }
    return nameMask;
  }

  nameMaskWithoutEmptySpace(rawValue: string): RegExp[] {
    const size = 32;
    const mask = /^[а-яА-ЯёЁa-zA-Z0-9._]+$/;
    const nameMask: RegExp[] = [];
    for (let i = 0; i <= size; i++) {
      nameMask.push(mask);
    }
    return nameMask;
  }

  serialNumberMask(rawValue: string): RegExp[] {
    const size = 32;
    const mask = /[a-zA-Z-А-Яа-я0-9]+/;
    const nameMask: RegExp[] = [];
    for (let i = 0; i <= size; i++) {
      nameMask.push(mask);
    }
    return nameMask;
  }

  passwordMask(rawValue: string): RegExp[] {
    const size = 32;
    const mask = /^[a-zA-Z0-9_.#@^*&=!~?%\\\[\]|/($)<>:-]+$/;
    const nameMask: RegExp[] = [];
    for (let i = 0; i <= size; i++) {
      nameMask.push(mask);
    }
    return nameMask;
  }

  simpleMask(rawValue: string): RegExp[] {
    const size = 32;
    const mask = /^[a-zA-Z0-9_.#@^*&=!~?%\\\[\]|/($)<>:-]+$/;
    const nameMask: RegExp[] = [];
    for (let i = 0; i <= size; i++) {
      if (mask.test(rawValue)) {
        nameMask.push(mask);
      }
    }
    return nameMask;
  }

  settings_translate_list = [];
  settings_saved_lang: string;
  error_data: string;
  cash_reset_lang: string;

  // для изменения z-index хэдера, чтобы не заслонял диалог
  header_change_zindex: boolean = false;

  last_space = false;

  //websocket setInterval(10000)
  websocket_connect: any;

  constructor(
    private http: AuthHttpService,
    public dialog: MatDialog,
    public router: Router,
    public translate: TranslateService,
    public clipboard: Clipboard
  ) {

    //translate
    this.changeLangCancel = this.langJS.subscribe(this.onLangChanged.bind(this));

    //this.getSystemParams();
  }

  //установка ws-url
  set_ws_url() {
    if (location.href.includes('localhost')) {
      //this.ws_url = 'wss://192.168.1.54:6969' //для дома
      this.ws_url = 'wss://192.168.89.254:6969'  //для офиса
    } else {
      this.ws_url = this.systemParams.find(param => param.name == 'WS_URL').value;
    }
  }

  //функция для проверки на первый и последний пробел
  checkSpaces(model: string) {
    //пробуем заменить последний пробел на его отсутвие
    let name_arr = model.split(/(\s+)/);
    let name_arr_last = name_arr[name_arr.length - 1];
    let name_arr_first = name_arr[0];
    //console.log('name_arr', name_arr.pop());
    this.last_space = !Boolean(name_arr_last) || !Boolean(name_arr_first);
  }

  // Mask for names
  nameMask(rawValue: string): RegExp[] {
    const mask = /^[a-zA-Zа-яА-ЯёЁ0-9-_'".*()\s]+$/;
    // const mask = /^[^\s][a-zA-Zа-яА-ЯёЁ0-9-_'".*()\s]*$/;
    const strLength = String(rawValue).length;
    const nameMask: RegExp[] = [];
    for (let i = 0; i <= strLength; i++) {
      nameMask.push(mask);
    }
    return nameMask;
  }

  onLangChanged() {

    forkJoin([
      this.translate.get('db_version_major_descr'), //0
      this.translate.get('db_version_minor_descr'), //1
      this.translate.get('db_version_build_descr'), //2
      this.translate.get('db_version_build_incr'), //3
      this.translate.get('db_version_build_txt'), //4
      this.translate.get('db_version_date_descr'), //5
      this.translate.get('ws_server_ip_port'), //6
      this.translate.get('websocket_url'), //7
      //this.translate.get('send_commands_descr'), //4
      //this.translate.get('pvr_storage_time_descr'), //5
      //this.translate.get('events_tracks_storage_time_descr'), //6
      //this.translate.get('stats_storage_time_descr'), //7
      //this.translate.get('objects_storage_time_descr'), //8
      this.translate.get('settings_saved'), //8
      this.translate.get('error_data'), //9
      this.translate.get('cash_reset'), //10
      this.translate.get('roads'), //11
      this.translate.get('road_types'), //12
      this.translate.get('types_of_lane'), //13
      this.http.get('/api/get-system-params'), //14
      this.translate.get('road_editor'),//15
      this.translate.get('cabinets'),//16
      this.translate.get('sensors'),//17
      this.translate.get('adapter_menu'),//18
      this.translate.get('on'),//19
      this.translate.get('off'),//20
    ]).subscribe((res) => {

      this.settings_saved_lang = res[8];
      this.error_data = res[9];
      this.cash_reset_lang = res[10];
      this.roads = res[11];
      this.road_type = res[12];
      this.lane_type = res[13];

      //перевод настроек разработчика
      this.systemParams = res[14].body;

      this.settings_translate_list = [];
      for (let index = 0; index < 8; index++) {
        this.settings_translate_list.push(res[index]);
      }

      this.systemParams.forEach((par: { description: string; }, i: number) => {
        par.description = this.settings_translate_list[i]
      });

      this.set_ws_url();
      //

      this.road_editor_lang = res[15];


      //подключение websocket
      // if(!this.SocketService.socket_open){
      //     this.websocket_connect_loop();
      // }

      this.cabinets_lang = res[16];
      this.sensors_lang = res[17];
      this.adapters_lang = res[18];
      this.switch_on_lang = res[19];
      this.switch_off_lang = res[20];

    });
  }

  public saveSystemParams() {
    let data: any = {};
    this.systemParams.forEach((param: { name: string; value: any; }) => {
      if (param.name.substr(0, 3) != 'DB_') {
        data[param.name] = param.value;
      }
    });
    let request = this.http.post('/api/save-system-params', data);
    request.subscribe(() => {
      this.dialog.open(CreateDialogComponent, <MatDialogConfig>{
        data: {
          text: this.settings_saved_lang,
          icon_class: "dialog-icon-success"
        }
      });
    }, () => {
      this.dialog.open(CreateDialogComponent, <MatDialogConfig>{
        data: {
          text: this.error_data,
          icon_class: "dialog-icon-warning"
        }
      });
    });
  }

  public resetCache() {
    this.http.get('/api/reset-all-cache').subscribe(() => {
      this.dialog.open(CreateDialogComponent, <MatDialogConfig>{
        data: {
          text: this.cash_reset_lang,
          icon_class: "dialog-icon-success"
        }
      });
    }, () => {
      this.dialog.open(CreateDialogComponent, <MatDialogConfig>{
        data: {
          text: this.error_data,
          icon_class: "dialog-icon-warning"
        }
      });
    });
  }

  lang_select: string;
  road_select: string;
  equipment_select: string;
  langList = [{code: "ru", name: "Русский"}, {code: "en", name: "English"}, {code: "es", name: "Español"}];

  // дефолтные аватары (css-классы)
  public avatars_default: any[] = [
    {"big": "avatar-default-1", "tn": "avatar-default-tn-1"},
    {"big": "avatar-default-2", "tn": "avatar-default-tn-2"},
    {"big": "avatar-default-3", "tn": "avatar-default-tn-3"},
    {"big": "avatar-default-4", "tn": "avatar-default-tn-4"},
    {"big": "avatar-default-5", "tn": "avatar-default-tn-5"},
    {"big": "avatar-default-6", "tn": "avatar-default-tn-6"}
  ]

  checkRoute() {
    if (this.urls.indexOf(this.router.url.toString()) > -1) {
      this.show_proj_sel = true;
    } else {
      this.show_proj_sel = false;
    }
  }

  //функция для дизабла вкладок на стр. проекты, юзеры, роли согласно привилегиям
  checkRights(tab: any) {
    let user_privs = [];
    if (Boolean(this.user)) {
      user_privs = this.user.role.privileges;
      switch (tab) {
        case "projects":
          if (user_privs.findIndex(p => p.privileges_id == 'c89cacc5-e683-d4bb-1c93-3c29a3eaf448') != -1) {
            return true;
          } else {
            return false;
          }
          break;
        case "users":
          if (user_privs.findIndex(p => p.privileges_id == '20ff326b-4970-c935-be8a-648272d6921d') != -1) {
            return true;
          } else {
            return false;
          }
          break;
        case "roles":
          if (user_privs.findIndex(p => p.privileges_id == '8a4b4591-1825-e0d9-e0a3-1c34d83ac5cc') != -1) {
            return true;
          } else {
            return false;
          }
          break;
      }
    }
  }

  // функция чтобы не давать вводить e,+,-,E в поля input type number
  numericOnly(event: { which: any; keyCode: any; }): boolean { // restrict  characters in  input type number
    const charCode = (event.which) ? event.which : event.keyCode;
    return !(charCode == 101 || charCode == 69 || charCode == 45 || charCode == 43);
  }
}
